import { useTheme } from '@mui/material/styles';
import { Grid, Divider, Container, Typography, Breadcrumbs } from '@mui/material';
// import EventListSection from '../sections/_dashboard/EventListSection';
import EventScoreOverviewSection from "../components/app/EventScoreOverviewSection";


// ----------------------------------------------------------------------

export default function EventOverviewPage() {
  const theme = useTheme();

  let event = {
    "id": 124,
    "name_en": "體適能25/26 #1",
    "name_zh": "體適能25/26 #1",
    "type": "org",
    "organization_id": 154,
    "start_at": "2025-10-20 04:55:15",
    "end_at": "2025-10-24 16:00:00",
    "participant_org": [
      154
    ],
  }

  return (
    <>
      <title> Event Overview </title>


      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">Home</Typography>
        </Breadcrumbs>

        <Typography variant="h4" sx={{ mb: 5 }}>
          活動成績總覽
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <EventScoreOverviewSection event={event} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
